import React, {useState, useEffect} from 'react';
import {observer} from "mobx-react";
import {useStores} from "../../stores/Context";
import {FormControl, FormSelect} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";
import styles from "./CreateForm.module.scss";

import FormConfiguration, {BoutonSupprimerWidget, TitreConfigurerPhidget, WidgetTitre} from "./FormConfiguration";
import axios from "axios";
import {getSaspQueryCOlumnNameById} from "../../utils/requests";
import {useParams} from "react-router-dom";
import PaletteCouleurs from "../PaletteCouleurs";
import BtnSvg from "../../boiteAOutils/BtnSvg";
import BtnAction from "../../boiteAOutils/BtnAction";
import RadioButton from "../../boiteAOutils/Formulaire/RadioButton";
import CreateIndicateurApercu from "./CreateIndicateurApercu";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import ModalPrimary from "../../boiteAOutils/ModalPrimary";

// Liste des ""couleur"" pour chaque type de mise en forme.
const listOfSeuilOther = {
    "smiley": ['😔', '😐', '😀'],
    "arrow": ['⤵️', '➡️', '⤴️', '⬆️'],
    "weather": ['⛈️', '🌦️', '🌥️', '☀️'],
    "geometric": ['#E62222', '#3498db', '#37d67a']
};

// Fonction pour obtenir la valeur d'une variable CSS
const getCssVariableValue = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
};

// Liste des seuils par défaut pour chaque type de mise en forme.
const defaultSeuils = {
    'geometric': [
        {"seu_couleur": getCssVariableValue('--SEIZO-rouge'), "seu_sens": "inferieur", "seu_valeur": 99}
        , {"seu_couleur": getCssVariableValue('--SEIZO-bleu'), "seu_sens": "=", "seu_valeur": 100}
        , {"seu_couleur": getCssVariableValue('--SEIZO-vert'), "seu_sens": "superieur", "seu_valeur": 100}
    ],
    'smiley': [
        {"seu_couleur": '😔', "seu_sens": "inferieur", "seu_valeur": 80},
        {"seu_couleur": '😐', "seu_sens": "=", "seu_valeur": 90},
        {"seu_couleur": '😀', "seu_sens": "superieur", "seu_valeur": 90}
    ],
    'arrow': [
        {"seu_couleur": "⤵️", "seu_sens": "inferieur", "seu_valeur": 80},
        {"seu_couleur": '➡️', "seu_sens": "=", "seu_valeur": 90},
        {"seu_couleur": "⤴️", "seu_sens": "superieur", "seu_valeur": 90}
    ],
    'weather': [
        {"seu_couleur": "️⛈️", "seu_sens": "inferieur", "seu_valeur": 80},
        {"seu_couleur": '🌦️', "seu_sens": "=", "seu_valeur": 90},
        {"seu_couleur": "🌥️", "seu_sens": "superieur", "seu_valeur": 90},
        {"seu_couleur": "☀️", "seu_sens": "superieur", "seu_valeur": 110}
    ]
};

const CreateIndicateur = observer(() => {
    const {createWidgetStore, widgetStore, uiStore, niveauxIndicateurStore} = useStores();
    const {ent} = useParams();

    const [fontSize, setFontSize] = useState(50)
    const [typeForm, setTypeForm] = useState('');
    const [listDonees, setListDonnees] = useState([]);
    const [listChampDonees, setListChampDonnees] = useState([]);
    const [verifWidgetName, setVerifWidgetName] = useState(false);
    const [verifWidgetDataSource, setVerifWidgetDataSource] = useState(false);
    const [verifWidgetDataSourceChamp, setVerifWidgetDataSourceChamp] = useState(false);

    const [WidgetName, setWidgetName] = useState('');
    const [WidgetType, setWidgetType] = useState('manuel');
    const [WidgetUnite, setWidgetUnite] = useState('');
    const [WidgetForme, setWidgetForme] = useState('carre');
    const [WidgetMisEnForme, setWidgetMisEnForme] = useState('geometric');
    const [WidgetValeur, setWidgetValeur] = useState(0);
    const [WidgetDataSource, setWidgetDataSource] = useState('');
    const [WidgetDataSourceChamp, setWidgetDataSourceChamp] = useState('');
    const [WidgetDataRefresh, setWidgetDataRefresh] = useState(0);

    const [showSourceForm, setShowSourceForm] = useState(false);
    const [listeSeuils, setlisteSeuils] = useState(defaultSeuils[WidgetMisEnForme]);
    const idTotem = widgetStore.idTotem;

    const [ValeurExemple, setValeurExemple] = useState(10);

    // Récupération du cookie sous forme de chaîne
    const cookieEntreprise = widgetStore.getCookie("currentEntrepriseInfos");
    const entrepriseInfos = (() => {
        if (!cookieEntreprise) return {};
        try { return JSON.parse(cookieEntreprise); } catch (_) {
            try { return JSON.parse(decodeURIComponent(cookieEntreprise)); } catch (__) { return {}; }
        }
    })();

    const getAllSasp = async () => {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/YDOS/getRequeteYdosByTotem/` + idTotem,
            {headers: {"Authorization": `Bearer ${widgetStore._token}`}});
        const list = res.data;
        setListDonnees(list);
    }

    useEffect(() => {
        getAllSasp();
        listDonees.length === 0 && getAllSasp();
    }, [])

    if (niveauxIndicateurStore.levels.length !== 1) {
        createWidgetStore.openPanelNiveaux();
    }


    // handle input change
    const handleSeuilInputChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...listeSeuils];
        if (name === "seu_valeur") {
            list[index][name] = value.replace(/[^0-9\,]+/g, ''); // supprime l'intégralité des caractères autres que des chiffres ou une virgule
        } else {
            list[index][name] = value;
        }
        setlisteSeuils(list);
    };

    const handleSeuilColorInputChange = (color, index) => {
        const colorSeuil = [...listeSeuils];
        colorSeuil[index] = {
            ...colorSeuil[index],
            seu_couleur: WidgetMisEnForme === 'geometric' ? color : color.target.value
        };
        setlisteSeuils(colorSeuil);
    }

    // handle click event of the Remove button
    const handleSeuilRemoveClick = index => {
        const list = [...listeSeuils];
        list.splice(index, 1);
        setlisteSeuils(list);
    };

    // handle click event of the Add button
    const handleSeuilAddClick = () => {
        var seu_couleur = listOfSeuilOther[WidgetMisEnForme][listeSeuils.length] ?? listOfSeuilOther[WidgetMisEnForme][0];
        setlisteSeuils([...listeSeuils, {seu_couleur: seu_couleur, "seu_sens": "=", seu_valeur: "100"}]);
    };

    if (niveauxIndicateurStore.currentIndex === 0) {
        createWidgetStore.closePanelNiveaux();
    }

    const rqSaspColumn = async (idDonnee) => {
        let columns = await getSaspQueryCOlumnNameById(idDonnee, ent);
        setListChampDonnees(columns);
    }

    useEffect(() => {
        // Si WidgetType est défini à "manuel" et que la valeur (d'affichage) est égale à 0 ou superieur à 1.
        if (WidgetType === 'manuel' && (WidgetValeur === 0 || WidgetValeur > 1) && WidgetMisEnForme === 'geometric') {
            setWidgetValeur(1); // On met la valeur par défaut pour le type 'manuel' avec cette mise en forme.
        }
        // Si WidgetType est défini à "manuel" et que la valeur (d'affichage) est égale à 0 ou 1.
        if (WidgetType === 'manuel' && (WidgetValeur === 0 || WidgetValeur === 1) && WidgetMisEnForme !== 'geometric') {
            setWidgetValeur(2); // On met la valeur par défaut pour le type 'manuel' avec cette mise en forme.
        }
    }, [WidgetType])

    useEffect(() => {
        const colorSeuil = [...listeSeuils];
        // Si WidgetMisEnForme est défini, on met à jour les couleurs des seuils.
        // Sinon, on met à jour le WidgetMisEnForme avec la valeur par défaut.
        // Pour les widgets déjà existants avant l'ajout des mises en forme.
        if (WidgetMisEnForme) {
            if (WidgetMisEnForme === 'geometric') {
                if (WidgetForme !== 'carre' && WidgetForme !== 'rond' && WidgetForme !== 'triangle') {
                    setWidgetForme('carre');
                }
            } else if(WidgetMisEnForme === 'smiley' || WidgetMisEnForme === 'arrow' || WidgetMisEnForme === 'weather') {
                setWidgetForme(WidgetMisEnForme);
            }
            colorSeuil.forEach((seuil, index) => {
                colorSeuil[index] = {
                    ...colorSeuil[index],
                    seu_couleur: defaultSeuils[WidgetMisEnForme][index]?.seu_couleur ? defaultSeuils[WidgetMisEnForme][index].seu_couleur : defaultSeuils[WidgetMisEnForme][0].seu_couleur
                };
            });
            setlisteSeuils(colorSeuil);
        } else {
            setWidgetMisEnForme('geometric');
        }
        // Si on crée un widget, on met la valeur par défaut, à chaque changement de mise en forme.
        if (typeForm === "creation") {
            setWidgetValeur(WidgetType === 'auto' ? 0 : WidgetMisEnForme === "geometric" ? 1 : 2);
            // Si on modifie un widget en changeant sa mis en forme en different de geometric
            // et que la valeur est egale à 1, on applique la valeur par default.
        } else if (typeForm === 'modification' && WidgetMisEnForme !== 'geometric' && WidgetValeur === 1) {
            setWidgetValeur(2);
            // Si on modifie un widget en changeant sa mis en forme en geometric
            // et que la valeur est superieur à 1, on applique la valeur par default.
        } else if (typeForm === 'modification' && WidgetMisEnForme === 'geometric' && WidgetValeur > 1) {
            setWidgetValeur(1);
        }
    }, [WidgetMisEnForme])

    useEffect(() => {
        if (createWidgetStore.idWidgetModification === '') {
            setTypeForm("creation");
            niveauxIndicateurStore.cleanup();
        } else {
            setTypeForm("modification");
            widgetStore.getWidgetDataConfigById(createWidgetStore.idWidgetModification)
                .then(value => {
                    niveauxIndicateurStore.loadNiveaux(createWidgetStore.idWidgetModification, 'modify', ent);
                    niveauxIndicateurStore.setCurrentWidgetId(createWidgetStore.idWidgetModification);
                    setWidgetName(value.nomWidget)
                    setWidgetUnite((value.config.ind_unite === null) ? "" : value.config.ind_unite)
                    setWidgetForme(value.config.ind_forme);
                    setWidgetMisEnForme(value.config.ind_misEnForme);
                    setWidgetValeur(value.config.ind_donnees);
                    setWidgetDataSource(value.config.ind_id_requete_ydos);
                    setWidgetType(value.config.ind_type);
                    setShowSourceForm(value.config.ind_type === 'auto');
                    setWidgetDataRefresh(value.config.ind_tmp_refresh);
                    setlisteSeuils(value.config.listeSeuils);
                    if (value.config.ind_type !== "manuel") {
                        rqSaspColumn(value.config.ind_id_requete_ydos);
                        setWidgetDataSourceChamp(value.config.ind_type_valeur);
                    }
                })
                .catch(error => {
                    uiStore.closePanel();
                    console.log("error", error)
                });
        }
    }, [createWidgetStore.idWidgetModification]);


    const addNiveau = (idWidget) => {
        niveauxIndicateurStore.addLevel(ent, idWidget);
    }

    // Fonction qui permet de scroller jusqu'à un élément passé en paramètre @id.
    const ScrollTo = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        }
    }

    function getData() {
        if (WidgetName === '') {
            setVerifWidgetName(true);
            ScrollTo('widgetName');
        } else if (WidgetDataSource === '' && WidgetType === 'auto') {
            setVerifWidgetDataSource(true);
            ScrollTo('dataSources');
        } else if (WidgetDataSourceChamp === '' && WidgetType === 'auto') {
            setVerifWidgetDataSourceChamp(true);
            ScrollTo('dataSources');
        } else {
            setVerifWidgetName(false);
            setVerifWidgetDataSource(false);
            setVerifWidgetDataSource(false);
            if (typeForm === "creation") {
                let idWidget = uuidv4()
                niveauxIndicateurStore.setCurrentWidgetId(idWidget);
                widgetStore.addWidgetAvailable(
                    {
                        idWidget: idWidget,
                        typeWidget: 'WidgetIndicateur',
                        nomWidget: WidgetName,
                        config: {
                            ind_forme: WidgetMisEnForme === "geometric" ? WidgetForme : WidgetMisEnForme,
                            ind_misEnForme: WidgetMisEnForme,
                            ind_donnees: WidgetValeur,
                            ind_unite: WidgetUnite,
                            ind_type: WidgetType,
                            ind_id_requete_ydos: WidgetDataSource,
                            ind_tmp_refresh: parseInt(WidgetDataRefresh),
                            ind_type_valeur: WidgetDataSourceChamp
                            , listeSeuils
                        }
                    }
                ).then((res) => {
                    addNiveau(idWidget);
                    widgetStore.updateWidgetAvailable({
                        idWidget: idWidget,
                        typeWidget: 'WidgetIndicateur',
                        nomWidget: WidgetName,
                        config: {
                            ind_forme: WidgetMisEnForme === "geometric" ? WidgetForme : WidgetMisEnForme,
                            ind_misEnForme: WidgetMisEnForme,
                            ind_donnees: WidgetValeur,
                            ind_type: WidgetType,
                            ind_unite: WidgetUnite,
                            ind_id_requete_ydos: WidgetDataSource,
                            ind_tmp_refresh: parseInt(WidgetDataRefresh),
                            ind_type_valeur: WidgetDataSourceChamp
                            , listeSeuils
                        }
                    });
                    widgetStore.loadWidgetsAvailable();
                    uiStore.backNivOAfterAddPhidget();
                    createWidgetStore.resetCreateWidget();
                    createWidgetStore.closePanelNiveaux();
                    niveauxIndicateurStore.cleanup();
                });
            } else if (typeForm === "modification") {
                widgetStore.updateWidgetAvailable({
                    idWidget: createWidgetStore.idWidgetModification,
                    typeWidget: 'WidgetIndicateur',
                    nomWidget: WidgetName,
                    config: {
                        ind_forme: WidgetMisEnForme === "geometric" ? WidgetForme : WidgetMisEnForme,
                        ind_misEnForme: WidgetMisEnForme,
                        ind_donnees: WidgetValeur,
                        ind_type: WidgetType,
                        ind_unite: WidgetUnite,
                        ind_id_requete_ydos: WidgetDataSource,
                        ind_tmp_refresh: parseInt(WidgetDataRefresh),
                        ind_type_valeur: WidgetDataSourceChamp
                        , listeSeuils
                    }
                });
                setTimeout(() => {
                    widgetStore.loadWidgetsAvailable();
                    uiStore.backNivOAfterAddPhidget();
                }, 500)
            }
        }
    }

    const handleChangeDonnee = (e) => {
        setWidgetDataSource(e.target.value)

        if (e.target.value === '') {
            setListChampDonnees([]);
        } else {
            rqSaspColumn(e.target.value);
        }
    }

 const handleChangeType = (e) => {
     const {checked} = e.target;
     if (!checked && entrepriseInfos.subscriber === false) {
         // Appel au store pour ouvrir le modal
         createWidgetStore.openModalPrimary({
             title: "Fonctionnalité réservée",
             message: "Le mode Dynamique est réservé aux abonnés Seizo. Pour plus d'informations, veuillez consulter cette page.",
             type: "info"
         });
         return;
     }
     setShowSourceForm(!checked);
     setWidgetType(checked ? 'manuel' : 'auto');
 }

    let source = 'mssql';
    if (WidgetDataSource !== '' && listDonees.length !== 0) {
        source = listDonees.find(el => el.id === parseInt(WidgetDataSource))?.don_source;
    }

    const renderSVG_misEnForme = (type = WidgetMisEnForme) => {
        const icons = {
            geometric: (
                <svg width="53" height="50" viewBox="0 0 53 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="29.5439" y="26.543" width="23.4568" height="23.4568" rx="1" fill="#00B0FF"/>
                    <path
                        d="M26.5172 1.5C26.9021 0.833334 27.8643 0.833333 28.2492 1.5L39.6145 21.1852C39.9994 21.8519 39.5183 22.6852 38.7485 22.6852H16.018C15.2482 22.6852 14.7671 21.8519 15.152 21.1852L26.5172 1.5Z"
                        fill="#00B0FF"
                    />
                    <ellipse cx="12.2596" cy="38.2714" rx="11.7284" ry="11.7284" fill="#00B0FF"/>
                </svg>
            ),
            smiley: <>😀</>,
            weather: <>🌤️</>,
            arrow: <>⬆️</>,
        };

        return icons[type] || "";
    };


    return (
        <>
            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Indicateur"}/>
            </div>

            <div className={"w-full relative"}>
                {niveauxIndicateurStore.currentLevel.type === 'form' && (
                    <div
                        className="absolute bg-white shadow-lg border -right-[350px] top-[150px] z-10 w-[300px] h-[450px] p-4 rounded">
                        <h4>Aperçu</h4>
                        <CreateIndicateurApercu listeSeuils={listeSeuils} WidgetMisEnForme={WidgetMisEnForme}
                                                WidgetForme={WidgetForme} WidgetName={WidgetName}
                                                WidgetUnite={WidgetUnite}
                                                WidgetValeur={WidgetValeur} ValeurExemple={ValeurExemple}/>

                        <div className={`${styles.form_add_widget}`}>
                            <label>Tester la valeur : </label>
                            <FormControl
                                style={{
                                    padding: "12px 18px",
                                    borderRadius: "4px",
                                    border: "1px solid var(--icon-black, #002335)",
                                    background: "var(--icon-light-BG, #FBFDFE)",
                                    // color: 'var(--icon-dark, #A8B0B3)',
                                    fontFamily: 'Nunito, Serif',
                                    fontSize: '26px',
                                    fontWeight: '700',
                                    lineHeight: '130%',
                                }}
                                value={ValeurExemple}
                                onChange={(e) => {
                                    setValeurExemple(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                )}


                {
                    niveauxIndicateurStore.levels.map((level, i) => (
                        level.type === 'form' && (
                            <div key={level.id} className={styles.listeChampsFormulaire}>
                                <div className={"flex justify-center"} style={{width: "100%"}}>
                                    <span
                                        className="mx-3 text-md font-medium text-gray-900 dark:text-gray-300">Dynamique</span>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" onChange={handleChangeType} value=""
                                               checked={showSourceForm === false} className="sr-only peer"/>
                                        <div
                                            className="w-14 h-7 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 bg-blue-600"></div>
                                    </label>
                                    <span
                                        className="mx-3 text-md font-medium text-gray-900 dark:text-gray-300">Manuel</span>
                                </div>

                                <div className={`${styles.form_add_widget}`} id={'widgetName'}
                                     style={verifWidgetName ? {border: '1px solid red'} : {}}>
                                    <label>Nom du phidget :</label>
                                    <FormControl
                                        style={{
                                            padding: "12px 18px",
                                            borderRadius: "4px",
                                            border: "1px solid var(--icon-black, #002335)",
                                            background: "var(--icon-light-BG, #FBFDFE)",
                                            // color: 'var(--icon-dark, #A8B0B3)',
                                            fontFamily: 'Nunito, Serif',
                                            fontSize: '26px',
                                            fontWeight: '700',
                                            lineHeight: '130%',
                                        }}
                                        placeholder={'Nom du phidget'}
                                        value={WidgetName}
                                        onChange={(e) => {
                                            setWidgetName(e.target.value)
                                        }}
                                    />
                                    {
                                        verifWidgetName && (
                                            <p className={"text-danger"}>Nom de phidget obligatoire !</p>
                                        )
                                    }
                                </div>

                                {
                                    showSourceForm && (
                                        <>
                                            <div className={styles.form_add_widget} id={'dataSources'}
                                                 style={verifWidgetDataSource || verifWidgetDataSourceChamp ? {border: '1px solid red'} : {}}>
                                                <label>Requêtes</label>

                                                <div style={{display: "flex"}}>
                                                    <FormSelect className={''} onChange={handleChangeDonnee}
                                                                value={WidgetDataSource}>
                                                        <option value={''}>Sélectionner une requête</option>
                                                        {
                                                            listDonees.map((el) => {
                                                                return (
                                                                    <option value={el.id}>{el.nom}</option>
                                                                )
                                                            })
                                                        }
                                                    </FormSelect>
                                                </div>
                                                {
                                                    verifWidgetDataSource && (
                                                        <p className={"text-danger"}>Choix du type de données obligatoire !</p>
                                                    )
                                                }
                                            </div>

                                            <div className={styles.form_add_widget}
                                                 style={verifWidgetDataSourceChamp ? {border: '1px solid red'} : {}}>
                                                <label>Champ</label>
                                                <FormSelect className={styles.input_add_widget} onChange={(e) => {
                                                    setWidgetDataSourceChamp(e.target.value);
                                                    if (typeForm === "modification" && e.target.value !== '') {
                                                        widgetStore.widgetsAvailable.filter(widget => widget.idWidget === createWidgetStore.idWidgetModification)[0].config.ind_type_valeur = e.target.value;
                                                    }
                                                }} value={WidgetDataSourceChamp}>
                                                    <option value={''}>Sélectionner un champ</option>
                                                    {
                                                        Array.isArray(listChampDonees) && listChampDonees.map((data) => (
                                                            <option value={data}>{data}</option>
                                                        ))
                                                    }
                                                </FormSelect>
                                                {
                                                    verifWidgetDataSourceChamp && (
                                                        <p className={"text-danger"}>Choix du champ de données obligatoire !</p>
                                                    )
                                                }
                                                {
                                                    WidgetDataSource && (
                                                        <>
                                                            <label className={"mt-4"}>Temps de rafraîchissement</label>
                                                            <FormSelect
                                                                className={styles.input_add_widget}
                                                                onChange={(e) => {
                                                                    setWidgetDataRefresh(e.target.value);
                                                                    if (typeForm === "modification" && e.target.value !== '' && e.target.value !== widgetStore.widgetsAvailable.filter(widget => widget.idWidget === createWidgetStore.idWidgetModification)[0].config.ind_tmp_refresh) {
                                                                        widgetStore.widgetsAvailable.filter(widget => widget.idWidget === createWidgetStore.idWidgetModification)[0].config.ind_tmp_refresh = e.target.value;
                                                                    }
                                                                }}
                                                                value={WidgetDataRefresh}
                                                            >
                                                                <option value={0}>Sans (si donnée J-1)</option>
                                                                <option value={300000}>5 minutes</option>
                                                                <option value={600000}>10 minutes</option>
                                                                <option value={900000}>15 minutes</option>
                                                                <option value={1800000}>30 minutes</option>
                                                                <option value={3600000}>1 heure</option>
                                                            </FormSelect>
                                                        </>
                                                    )
                                                }

                                            </div>
                                        </>
                                    )}


                                <div className={styles.form_add_widget}>
                                    <label>Unité:</label>
                                    <FormControl
                                        style={{
                                            padding: '12px 18px',
                                            borderRadius: "4px",
                                            border: "1px solid var(--icon-black, #002335)",
                                            fontFamily: 'Nunito, Serif',
                                            fontSize: '18px',
                                            fontWeight: '700',
                                            lineHeight: '130%',
                                        }}
                                        className={styles.input_add_widget} value={WidgetUnite}
                                        maxLength={8}
                                        placeholder={"%, Kg, etc."}
                                        onChange={(e) => {
                                            setWidgetUnite(e.target.value)
                                        }}
                                    />
                                </div>

                                <div className={styles.form_add_widget} style={{
                                    width: "100%",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between"
                                    , alignItems: "stretch"
                                    , flexDirection: "row"
                                    , gap: 0
                                }}>
                                    <div>
                                        <label>Mise en forme :</label>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            justifyContent: "space-between"
                                        }}>
                                            {[
                                                {value: "geometric", content: renderSVG_misEnForme("geometric")},
                                                {value: "smiley", content: renderSVG_misEnForme("smiley")},
                                                {value: "arrow", content: renderSVG_misEnForme("arrow")},
                                                {value: "weather", content: renderSVG_misEnForme("weather")},
                                            ].map(({value, content}) => (
                                                <div key={value} style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "space-between"
                                                }}>
                                                    <p style={{fontSize: "40px"}}>{content}</p>
                                                    <RadioButton
                                                        value={value}
                                                        checked={WidgetMisEnForme === value}
                                                        onChange={(e) => setWidgetMisEnForme(e.target.value)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                    {WidgetMisEnForme !== "geometric" && (
                                        <div>
                                            <label>Position de la valeur :</label>
                                            <div
                                                className={'flex flex-row justify-around align-items-center'}>
                                                <div>
                                                    <RadioButton value={4}
                                                                 checked={WidgetValeur === 4 ? 'checked' : ''}
                                                                 onChange={(e) => {
                                                                     setWidgetValeur(parseInt(e.target.value))
                                                                 }}/>
                                                </div>
                                                <div className={'flex flex-col align-items-center gap-2'}>
                                                    <RadioButton value={2}
                                                                 checked={WidgetValeur === 2 ? 'checked' : ''}
                                                                 onChange={(e) => {
                                                                     setWidgetValeur(parseInt(e.target.value))
                                                                 }}/>

                                                    {renderSVG_misEnForme()}

                                                    <RadioButton value={3}
                                                                 checked={WidgetValeur === 3 ? 'checked' : ''}
                                                                 onChange={(e) => {
                                                                     setWidgetValeur(parseInt(e.target.value))
                                                                 }}/>
                                                </div>
                                                <div>

                                                    <RadioButton value={5}
                                                                 checked={WidgetValeur === 5 ? 'checked' : ''}
                                                                 onChange={(e) => {
                                                                     setWidgetValeur(parseInt(e.target.value))
                                                                 }}/>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {WidgetMisEnForme === "geometric" && (
                                        <div>
                                            <label>Forme du phidget :</label>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                justifyContent: "space-between"
                                            }}>

                                                {[
                                                    {
                                                        value: "carre",
                                                        render: (
                                                            <div style={{
                                                                width: "32px",
                                                                height: "32px",
                                                                borderRadius: "1px",
                                                                background: "var(--icon-accent, #00B0FF)"
                                                            }}></div>
                                                        )
                                                    },
                                                    {
                                                        value: "rond",
                                                        render: (
                                                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <ellipse cx="16" cy="16" rx="16" ry="16"
                                                                         fill="#00B0FF"/>
                                                            </svg>
                                                        )
                                                    },
                                                    {
                                                        value: "triangle",
                                                        render: (
                                                            <svg width="36" height="31" viewBox="0 0 36 31" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M17.134 0.500002C17.5189 -0.166665 18.4811 -0.166667 18.866 0.5L35.3205 29C35.7054 29.6667 35.2243 30.5 34.4545 30.5H1.54552C0.775719 30.5 0.294592 29.6667 0.679492 29L17.134 0.500002Z"
                                                                    fill="#00B0FF"/>
                                                            </svg>
                                                        )
                                                    }
                                                ].map(({value, render}) => (
                                                    <div key={value} style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        gap: "20px"
                                                        , padding: "2px"
                                                    }}>
                                                        {render}
                                                        <RadioButton
                                                            name="form_widget"
                                                            value={value}
                                                            checked={WidgetForme === value ? 'checked' : ''}
                                                            onChange={(e) => setWidgetForme(e.target.value)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>


                                <div className={styles.form_add_widget} style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "right"
                                }}>
                                    <div className="sous_titre">
                                        <div className="contenu">
                                            <span>Seuils</span>
                                        </div>
                                        <div className="line"></div>
                                    </div>

                                    <div className={"listeSeuils"}>
                                        {
                                            listeSeuils.map((SEUIL, i) => {
                                                return (
                                                    <div className={"element"}>
                                                        {WidgetMisEnForme === "geometric" ? (
                                                            <PaletteCouleurs defaultColor={SEUIL.seu_couleur}
                                                                             width={"70px"} height={"35px"}
                                                                             onColorChange={(e) => handleSeuilColorInputChange(e, i)}/>
                                                        ) : (
                                                            <FormSelect name={"seu_ambiant"}
                                                                        value={SEUIL.seu_couleur}
                                                                        onChange={e => handleSeuilColorInputChange(e, i)}>
                                                                {
                                                                    Object.keys(listOfSeuilOther).map((key) => {
                                                                        if (key === WidgetMisEnForme) {
                                                                            return listOfSeuilOther[key].map((el, ind) => {
                                                                                return (
                                                                                    <option
                                                                                        value={el}>{el}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                        return null;
                                                                    })
                                                                }
                                                            </FormSelect>
                                                        )}

                                                        <FormSelect name={"seu_sens"} value={SEUIL.seu_sens}
                                                                    onChange={e => handleSeuilInputChange(e, i)}>
                                                            <option value="inferieur">&lt;</option>
                                                            <option value="inferieur_egal">&lt;=</option>
                                                            <option value="superieur">&gt;</option>
                                                            <option value="superieur_egal">&gt;=</option>
                                                            <option value="=">=</option>
                                                        </FormSelect>
                                                        <FormControl className={styles.input_add_widget}
                                                                     value={SEUIL.seu_valeur}
                                                                     name={"seu_valeur"}
                                                                     onChange={e => handleSeuilInputChange(e, i)}
                                                        />
                                                        {listeSeuils.length !== 1 && <BtnSvg svg={"corbeille"}
                                                                                             onClick={() => handleSeuilRemoveClick(i)}/>}
                                                    </div>
                                                )
                                            })
                                        }
                                        <div><BtnAction onClick={handleSeuilAddClick}>+ Ajouter un
                                            seuil</BtnAction></div>
                                    </div>
                                </div>

                                <div className={styles.WidgetButtonContent}>
                                    {(createWidgetStore.idWidgetModification === '') ? <FormConfiguration/> :
                                        <BoutonSupprimerWidget
                                            idWidget={createWidgetStore.idWidgetModification}
                                            widgetName={WidgetName}
                                            typeWidget={"WidgetIndicateur"}
                                        />}
                                    <BtnPrimary
                                        onClick={getData}>{(createWidgetStore.idWidgetModification === '') ? "Ajouter à mes phidgets" : "Modifier mon phidget"}</BtnPrimary>
                                </div>
                            </div>
                        )
                    ))
                }
            </div>

            {createWidgetStore.modalPrimary.open && (
                <ModalPrimary
                    textTitle={createWidgetStore.modalPrimary.title}
                    textComment={createWidgetStore.modalPrimary.message}
                    // showValidateBtn={false}
                    // showCancelBtn={true}
                    textBtnValidate="OK"
                    textBtnCancel="Annuler"
                    textURL="S'abonner"
                    URL="https://www.seizo.fr/pricing-plans/list"
                    onCancel={() => createWidgetStore.closeModalPrimary()}
                />
            )}
        </>
    );
});

export default CreateIndicateur;
